<template>
  <BreadCrumb PageTitle="Auto System Classification" />
  <div class="row">
    <div class="col-xxl-12">
      <div class="row">
        <div class="col-lg-12 d-flex">
          <div class="card mb-25 border-0 rounded-0 bg-white flex-grow-1">
            <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
              <CreateAutoSystemClassification :leadID="leadID" :dataStreamID="dataStreamID" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import BreadCrumb from '../../../components/Common/DynamicBreadCrumb.vue';
import CreateAutoSystemClassification from '../../../components/ELSA/AutoSystemClassification/CreateAutoSystemClassification.vue';

const parseRouteParam = (value: unknown): number | null => {
  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }
  if (Array.isArray(value) && value.length > 0) {
    const parsed = parseInt(value[0] as string, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }
  return null;
};

export default defineComponent({
  name: 'AutoSystemClassificationPage',
  components: {
    BreadCrumb,
    CreateAutoSystemClassification
  },
  setup() {
    const route = useRoute();
    const leadID = ref<number | null>(null);
    const dataStreamID = ref<number | null>(null);

    const updateFromRoute = () => {
      leadID.value = parseRouteParam(route.params.leadID);
      dataStreamID.value = parseRouteParam(route.params.dataStreamID);
    };

    onMounted(() => {
      updateFromRoute();
    });

    watch(
      () => route.params,
      () => {
        updateFromRoute();
      }
    );

    return {
      leadID,
      dataStreamID
    };
  }
});
</script>

<style scoped>
.card {
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
}

.letter-spacing {
  letter-spacing: 0.5px;
}
</style>
